module.exports = __webpack_public_path__ + "static/media/current-logo-white.294ce006.png";